import React, {useEffect, useState} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import CashDepositIndexDataTable from './CashDepositIndexDataTable';
import { getAllPrograms } from '@/shared/apiHelper.jsx';
import {isEmpty} from '@/shared/helpers'
// import axios from "axios";
// import {isEmpty} from '@/shared/helpers'
// import {withRouter} from "react-router-dom";
// import {connect} from "react-redux";
// import { getPrograms } from '@/shared/apiHelper.jsx';

const CashDepositIndex = ({organization}) => {

    const [defaultPrograms, setDefaultPrograms] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getAllPrograms("minimal=true&limit=99999999&is_pay_in_advance=1")
            .then(response => {
                const data = response?.data ? response.data : [];
                const result = data.map(x => x.account_holder_id);
                setDefaultPrograms(result);
                setLoading(false);
            })
            .catch(() => {
                setDefaultPrograms([]);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <p>Loading...</p>;
    }


    return (
    <Col md={12}>
      <Card>
        <CardBody>
          <CashDepositIndexDataTable programs={defaultPrograms} />
        </CardBody>
      </Card>
    </Col>
  )
}
export default CashDepositIndex
// export default withRouter(connect((state) => ({
//   organization: state.organization
// }))(CashDepositIndex));
